import { getPlatformUrlParts } from '@acl-services/highbond-common';
import { API_VERSION } from '@issuemanager/constants';

export const getAppConfig = (windowLocation: string) => {
  const {
    protocol, // https
    // orgSubdomain, // my-org
    region, // ca
    domain, // highbond-gov
    domainSuffix, // -s1/2/3
    tld, // com
    appSubdomain, // issuemanager
  } = getPlatformUrlParts(windowLocation);

  const appSubdomainWithoutRegion = appSubdomain
    .split('-')
    .filter((item) => item !== region)
    .join('-');

  const host = `${domain}${domainSuffix}.${tld}`;
  const apiRegionWithoutUs = region === 'us' || !region ? '' : `-${region}`;

  const apiUrl = `${protocol}://new-api-${appSubdomainWithoutRegion}${apiRegionWithoutUs}.${host}/${API_VERSION}`;

  const isLocalDev = isLocalhost(windowLocation);

  return {
    loginUrl: isLocalDev ? '' : `${protocol}://accounts.${host}/login`,
    tokenRefreshUrl: isLocalDev
      ? ''
      : `${protocol}://accounts.${host}/api/token/refresh`,
    sessionUrl: isLocalDev
      ? ''
      : `${protocol}://authy-api${apiRegionWithoutUs}.${host}/session`,
    platformHeaderScriptUrl: isLocalDev
      ? ''
      : `${protocol}://web-components.${host}/global-navigator/index.js`,
    isLocalDev,
    apiUrl: isLocalDev ? getLocalApiUrl(windowLocation) : apiUrl,
  };
};

function isHostDockerInternal(url: string) {
  return url.startsWith('http://host.docker.internal:');
}

function isLocalhost(url: string) {
  return (
    url.startsWith('http://localhost:') ||
    url.startsWith('https://localhost:') ||
    url.startsWith('http://0.0.0.0:') ||
    isHostDockerInternal(url)
  );
}

function getLocalApiUrl(windowLocation: string): string {
  if (isHostDockerInternal(windowLocation)) {
    return 'http://host.docker.internal:3000';
  }
  return 'http://localhost:3000';
}

export function isProductionEnv(windowLocation: string) {
  const { domainSuffix } = getPlatformUrlParts(windowLocation);

  return domainSuffix === '' && !isLocalhost(windowLocation);
}
